<template>
  <div class="setBreadNav flexBetween">
     <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>{{$t("wm_lang_html_53cab4")}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$t("wm_lang_html_7fc88a")}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'setBreadNav',
  data () {
    return {
      msgindex: this.$i18n.t('wm_lang_c14d45')
    }
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/sub/setBreadNav.vue